import { useIntl } from 'react-intl';

import { useAuth } from '@verantos-dev/core-auth';
import { PageHeaderAction } from '@verantos-dev/shared-components';

import { DialogActionType, useUsersListDialogContext } from '../context/UsersListDialogContext';

export const useUsersListHeader = () => {
  const intl = useIntl();

  const title = intl.formatMessage({ id: 'users.title' });
  const createUserBtn = intl.formatMessage({ id: 'users.createUserBtn' });
  const {
    user: { isAdmin },
  } = useAuth();

  const { dispatch } = useUsersListDialogContext();

  const createUserActionBtn: PageHeaderAction[] = isAdmin
    ? [
        {
          id: 'add-user',
          label: createUserBtn,
          startIcon: 'add',
          onClickHandler: () => {
            dispatch({ type: DialogActionType.OPEN_DIALOG, payload: 'createUser' });
          },
        },
      ]
    : [];

  return {
    title,
    createUserBtn,
    createUserActionBtn,
  };
};
